/**
 * @desc 导入费用校验
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/checkImportTrackExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
